@if (title() && value && value.length) {
    <div class="title">
        {{ title() }}
    </div>
}
@if (!isDisabled()) {
    <button class="buttons" mat-icon-button matTooltip="{{ 'Add table' | translate }}" type="button" (click)="openAddTableDialog()">
        <mat-icon>
            crop_portrait
        </mat-icon>
    </button>
    <button class="buttons" mat-icon-button matTooltip="{{ 'Add multiple tables' | translate }}" type="button" (click)="openAddMultipleTablesDialog()">
        <mat-icon>
            content_copy
        </mat-icon>
    </button>
    @if (allowPrefill) {
        <button class="buttons" mat-icon-button matTooltip="{{ 'PrefillTables' | translate }}" type="button" (click)="prefillTables()">
            <mat-icon>
                edit_note
            </mat-icon>
        </button>
    }
    <button class="buttons" mat-icon-button matTooltip="{{ 'ClearTables' | translate }}" type="button" (click)="clearTables()">
        <mat-icon>
            delete_outline
        </mat-icon>
    </button>
    <mat-divider class="divider"></mat-divider>
}
@if (value && value.length) {
    <mat-grid-list [cols]="(['xs', 'sm'] | breakpoint | async) ? 4 : 8" [gutterSize]="'0.5rem'">
        @for (cecTable of value; track cecTable; let i = $index) {
            @if (isDisabled()) {
                <mat-grid-tile>
                    <div 
                        class="table-box" 
                        [class]="corrected ? evaluateTableClassAfterCorrection(cecTable) : evaluateTableClass(cecTable)"
                    >
                        <span class="table-title noselect">{{ evaluateButtonName(cecTable) }}</span>
                    </div>
                </mat-grid-tile>
            } @else {
                <mat-grid-tile cdkDropList [cdkDropListConnectedTo]="drops" [cdkDropListData]="i">
                    <div
                        cdkDrag
                        (cdkDragEntered)="entered($event)"
                        [cdkDragData]="i"
                        class="table-box"
                        [class]="evaluateTableClass(cecTable)"
                        (click)="openEditTableDialog(cecTable)"
                    >
                        <mat-icon matTooltip="{{ 'Remove table' | translate }}" (click)="removeTable(i)"> cancel </mat-icon>
                        <span class="table-title noselect">{{ evaluateButtonName(cecTable) }}</span>
                    </div>
                </mat-grid-tile>
            }
        }
    </mat-grid-list>
    @if (showWrittenLegend()) {
        <div class="legend">
            <div class="element">
                <div class="tile classic-table"></div>
                {{ 'Classic' | translate }}
            </div>
            <div class="element">
                <div class="tile lifestamp-table"></div>
                {{ 'LifeStamp' | translate }}
            </div>
        </div>
    } @else if (showCorrectLegend()) {
        <div class="legend">
            <div class="element">
                <div class="tile classic-table"></div>
                {{ 'Classic' | translate }}
            </div>
            <div class="element">
                <div class="tile lifestamp-table"></div>
                {{ 'LifeStamp' | translate }}
            </div>
            <div class="element">
                <div class="tile yes-or-not-table"></div>
                {{ 'YesOrNot' | translate }}
            </div>
            <div class="element">
                <div class="tile or-table"></div>
                {{ 'Or' | translate }}
            </div>
            <div class="element">
                <div class="tile cancelled-table"></div>
                {{ 'Cancelled' | translate }}
            </div>
        </div>
    } @else if (showCorrectedLegend()) {
        <div class="legend">
            <div class="element">
                <div class="tile ok-table"></div>
                {{ 'Correct' | translate }}
            </div>
            <div class="element">
                <div class="tile more-table"></div>
                {{ 'More' | translate }}
            </div>
            <div class="element">
                <div class="tile missing-table"></div>
                {{ 'Missing' | translate }}
            </div>
        </div>
    }
    <mat-divider class="divider"></mat-divider>
}